import { t } from 'i18next';
import {userDataTransform} from "../../../Apis/functions";

export const APPROVAL_MODEL = {
    id:null,
    approvalFlowName: '',
    department: null,
    module: null,
    toRegister: function (levels) {
        return {
            id:this.id,
            approvalFlowName: this.approvalFlowName,
            departmentDTO: {id:this.department},
            moduleDTO: {id:this.module},
            levels: levels.map(e => {
                return {
                    ...e,
                    approvers: e.approvers.map(row => {
                    return { user: { id: row.id, name: row.label } }
                })}
            })
        }
    },
    set: function (data) {
        return {
            ...this,
            id:data.id,
            approvalFlowName: data.approvalFlowName,
            department: data.departmentDTO?.id,
            module: data.moduleDTO.id,
        }
    },
    isValid: function () {
        return this.approvalFlowName !== '' && this.module != null;
    },
    isValidLevels: function (levels) {
        return levels.filter(e => e.approvers.length === 0).length <= 0;
    }
}


export const LEVEL_MODEL = {
    id:null,
    levelNumber: 1,
    approvalCondition: 'ONE_IS_ENOUGH',
    approvers: [],
    set: function (data) {
        return data?.map(e => {
            return {
                ...e,
                approvers: e?.approvers?.length > 0 ? e.approvers.map(x => {
                    return {id: x.user.id, label: userDataTransform(x.user)}
                }): []
            }
        }).sort((a, b) => a.levelNumber - b.levelNumber);
    },
    isValid: function (levels) {
        return levels.filter(e => e.approvers.length === 0).length <= 0;
    }
}

export const SCOPE_MODEL = () => {
    return [
        { id: 'ALL_MUST_APPROVE', name: t('all_must_approve')},
        { id: 'ONE_IS_ENOUGH', name: t('one_is_enough')},
    ];
};
